'use strict';

const SocialNetworkStore = require('../stores/SocialNetworkStore');
let isFetched = false;

const socialNetworkActions = {

    fetch(actionContext, payload, done) {
        if (isFetched) {
            done();
        } else {
            const store = actionContext.getStore(SocialNetworkStore);
            const collection = store.getCollection();
            isFetched = true;

            Promise.resolve(collection.fetch())
                .then(() => {
                    actionContext.dispatch('socialNetworks:fetch', collection.toJSON());
                    done();
                });
        }
    }

};

module.exports = socialNetworkActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/socialNetworkActions.es.js